<div class="modal-form container">
    <h2 mat-dialog-title class="jumbotron-heading">Edit Pricing Preferences</h2>
    <div>For agent-adjusted pricing.</div>

    <div class="Vert-25"></div>

    <mat-dialog-content class="mat-typography">
        <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>
        <form [formGroup]="pricingPreferencesForm">

            <div class="edit">

                <div class="form showUnTouchedInvalidFields">
                    <div class="col-12">
                        <mat-error *ngIf="pricingPreferencesForm.invalid">Fields with * are required</mat-error>
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Target Price</mat-label>
                            <input type="text" matInput formControlName="targetPrice" required>
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Maximum Fee</mat-label>
                            <input type="text" matInput formControlName="maxFee" required>
                        </mat-form-field>
                    </div>
                </div>
                <div class="Vert-25"></div>

                <div class="row">
                    <div class="col-12" align="end">

                        <button mat-button class="btn btn-primary float-end" (click)="onSubmit()"
                                [disabled]="(isLoading$ | async) || !pricingPreferencesForm.valid">
                            Submit
                        </button>

                        <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                                style="margin-right:10px;">
                            Cancel
                        </button>
                    </div>
                </div>
                <div class="Vert-15"></div>

            </div>

        </form>
    </mat-dialog-content>

</div>
